const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us"],
  "onlineqrcode.com": ["/pricing"],
  "app.onlineqrcode.com": ["/pricing"],
  "qrnow.com": ["/pricing"],
  "app.qrnow.com": ["/pricing"],
};

module.exports = {
  indexedPaths,
};
